export default {
	task_add_activity_to_existing: 'Zu bestehender Aufgabe hinzufügen',
	task_alarm: 'Alarmierung',
	task_alarm_active: 'Alarmierung',
	task_alarm_active_activated: 'aktiviert',
	task_alarm_active_deactivated: 'deaktiviert',
	task_alarm_date_and_time_label: 'Datum und Zeit',
	task_alarm_owner_type_label: 'Ersteller',
	task_alarm_owner_type_option_always: 'immer',
	task_alarm_owner_type_option_never: 'niemals',
	task_alarm_owner_type_option_onlyOnUnfinished: 'bei offenen',
	task_alarm_user: 'Benutzer',
	task_create_from_activity: 'Neue Aufgabe aus Aktivität erstellen',
	task_create_from_activity_error: 'Die Aufgabe konnte nicht erstellt werden.',
	task_created_for_label: 'Angelegt für',
	task_datefield_close: 'Schließen',
	task_delete_dialog_confirm_cancel_label: 'Nein',
	task_delete_dialog_confirm_message: 'Möchten Sie diese Aufgabe wirklich löschen?',
	task_delete_dialog_confirm_ok_label: 'Ja',
	task_delete_dialog_confirm_title: 'Aufgabe löschen',
	task_fixed_description_label: 'Beschreibung',
	task_fixed_maturity_date_label: 'Fälligkeit',
	task_link_activity_error_already_linked: 'Die Aktivität ist bereits mit dieser Aufgabe verbunden.',
	task_link_activity_error_conflict: 'Die Aufgabe wurde zwischenzeitlich geändert. Bitte erneut versuchen.',
	task_link_activity_error_forbidden: 'Sie dürfen diese Aktivität nicht mit der Aufgabe verbinden.',
	task_link_activity_error_invalid_origin: 'Die Aktivität kann nicht verbunden werden.',
	task_link_activity_error_invalid_url: 'Die URL kann nicht mit der Aufgabe verbunden werden.',
	task_link_activity_error_task_locked: 'Die Aufgabe ist momentan gesperrt.',
	task_link_activity_error_task_not_open: 'Die ausgewählte Aufgabe ist nicht mehr offen.',
	task_link_activity_error_transport_error: 'Die Verbindung konnte nicht gespeichert werden.',
	task_link_activity_error_validation_failed: 'Die Verbindung konnte nicht validiert werden.',
	task_link_activity_url_cancel: 'Abbrechen',
	task_link_activity_url_context_action: 'Aktivität über URL hinzufügen',
	task_link_activity_url_dialog_title: 'Aktivität über URL verknüpfen',
	task_link_activity_url_label: 'Interne Aktivitäts-URL',
	task_link_activity_url_placeholder: 'Aktivitäts-URL einfügen',
	task_link_activity_url_refresh_error:
		'Die Aktivität wurde verknüpft, aber die Aufgabe konnte nicht aktualisiert werden.',
	task_link_activity_url_submit: 'Hinzufügen',
	task_link_activity_url_success: 'Die Aktivität wurde mit der Aufgabe verbunden.',
	task_linked_activities: 'Verbundene Aktivitäten',
	task_linked_activities_drop_empty: 'Aktivitäten hierher ziehen, um sie mit der Aufgabe zu verbinden.',
	task_linked_activities_empty: 'Keine verbundenen Aktivitäten',
	task_linked_activity: 'Verbundene Aktivität',
	task_linked_activity_contact: 'Kontakt',
	task_linked_activity_date: 'Datum',
	task_linked_activity_date_time: 'Datum/Zeit',
	task_linked_activity_duplicate: 'Diese Aktivität ist bereits verbunden.',
	task_linked_activity_information: 'Information',
	task_linked_activity_open: 'Aktivität öffnen',
	task_linked_activity_remove: 'Verbindung entfernen',
	task_linked_activity_remove_confirm_cancel_label: 'Nein',
	task_linked_activity_remove_confirm_message: 'Möchten Sie diese Verbindung wirklich entfernen?',
	task_linked_activity_remove_confirm_ok_label: 'Ja',
	task_linked_activity_remove_confirm_title: 'Verbindung entfernen',
	task_linked_activity_remove_error_task_locked: 'Die Aufgabe ist momentan gesperrt.',
	task_linked_activity_remove_error_task_not_open: 'Die Aufgabe ist nicht mehr offen.',
	task_linked_activity_remove_error_transport_error: 'Die Verbindung konnte nicht entfernt werden.',
	task_linked_activity_remove_refresh_error:
		'Die Verbindung wurde entfernt, aber die Aufgabe konnte nicht aktualisiert werden.',
	task_linked_activity_remove_success: 'Die Verbindung wurde entfernt.',
	task_linked_activity_type: 'Typ',
	task_linked_activity_unavailable: 'Nicht verfügbar oder gelöscht',
	task_linked_activity_unknown_module: 'Unbekannte Aktivität',
	task_linked_activity_unsupported: 'Dieser Aktivitätstyp kann nicht verbunden werden.',
	task_linked_tasks_open_aria_label: 'Aufgabe „{title}“ öffnen',
	task_linked_tasks_task_label: 'Aufgabe',
	task_linked_tasks_title: 'Verbundene Aufgaben',
	task_next_week: 'In die nächste Woche',
	task_next_week_notification: 'Aufgabe wurde in die nächste Woche verschoben',
	task_open_picker_cancel: 'Abbrechen',
	task_open_picker_close: 'Schließen',
	task_open_picker_empty: 'Keine offenen Aufgaben gefunden.',
	task_open_picker_error: 'Die offenen Aufgaben konnten nicht geladen werden.',
	task_open_picker_filtered_empty: 'Keine offenen Aufgaben entsprechen der Suche.',
	task_open_picker_linked_confirmation: 'Aktivität wurde zur Aufgabe hinzugefügt.',
	task_open_picker_linked_status: 'Hinzugefügt',
	task_open_picker_loading: 'Offene Aufgaben werden geladen…',
	task_open_picker_search: 'Offene Aufgaben durchsuchen',
	task_open_picker_submit: 'Hinzufügen',
	task_open_picker_title: 'Zu bestehender Aufgabe hinzufügen',
	task_repetition_active: 'Wiederholung',
	task_repetition_count_end_label: 'Anzahl Wiederholungen',
	task_repetition_delete_scope_all: 'inkl. aller folgenden Wiederholungsaufgaben',
	task_repetition_delete_scope_message: 'Welche Aufgaben sollen gelöscht werden?',
	task_repetition_delete_scope_single: 'Nur diese Aufgabe',
	task_repetition_delete_scope_title: 'Aufgabe löschen',
	task_repetition_end_date_label: 'Enddatum',
	task_repetition_end_option_by_number: 'nach Anzahl',
	task_repetition_end_option_never: 'nie (bis 2038)',
	task_repetition_end_option_on_fixed_date: 'an fixem Datum',
	task_repetition_ends: 'Endet',
	task_repetition_interval: 'Intervall',
	task_repetition_monthly_rule_by_day: 'Tag',
	task_repetition_monthly_rule_by_weekday: 'nach Wochentag',
	task_repetition_monthly_rule_label: 'Monatsregel',
	task_repetition_off: 'deaktiviert',
	task_repetition_on: 'aktiviert',
	task_repetition_save_scope_all: 'inkl. aller folgenden Wiederholungsaufgaben',
	task_repetition_save_scope_message: 'Welche Aufgaben sollen gespeichert werden?',
	task_repetition_save_scope_single: 'Nur diese Aufgabe',
	task_repetition_save_scope_title: 'Aufgabe speichern',
	task_repetition_type_daily: 'täglich',
	task_repetition_type_label: 'Art',
	task_repetition_type_monthly: 'monatlich',
	task_repetition_type_none: 'deaktiviert',
	task_repetition_type_weekly: 'wöchentlich',
	task_repetition_type_yearly: 'jährlich',
	task_repetition_weekday_friday: 'Fr',
	task_repetition_weekday_monday: 'Mo',
	task_repetition_weekday_saturday: 'Sa',
	task_repetition_weekday_sunday: 'So',
	task_repetition_weekday_thursday: 'Do',
	task_repetition_weekday_tuesday: 'Di',
	task_repetition_weekday_wednesday: 'Mi',
	task_repetition_weekdays_label: 'Wochentage',
	task_save_failed_notification: 'Aufgabe konnte nicht gespeichert werden',
	task_saved_notification: 'Aufgabe wurde gespeichert',
	task_tomorrow: 'Auf morgen',
	task_tomorrow_notification: 'Aufgabe wurde auf morgen verschoben',
	task_version_author: 'Autor',
	task_version_dialog_cancel: 'Abbrechen',
	task_version_dialog_confirm_cancel_label: 'Nein',
	task_version_dialog_confirm_message: 'Möchten Sie diese Version wirklich löschen?',
	task_version_dialog_confirm_ok_label: 'Ja',
	task_version_dialog_confirm_title: 'Task Version löschen',
	task_version_time: 'Datum',
	task_version_title: 'Titel',
	task_version_versions: 'Versionen',
};
